export const iconFontAwesomeBuildingsBuildingFlag = (
	<i className="fa-solid fa-building-flag"></i>
);
